import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=5d6bdede&scoped=true"
import script from "./TaskCreate.vue?vue&type=script&lang=ts"
export * from "./TaskCreate.vue?vue&type=script&lang=ts"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=5d6bdede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bdede",
  null
  
)

export default component.exports